// @flow
import { TOUR_PROGRAM } from 'Client/cms/toolkit/constants';
import { TourProgramLine } from 'Components/lines/tour-program-line/TourProgramLine';
import { tourProgramResolver } from './tourProgram.resolver';

export const tourProgramDescriptor = {
  name: TOUR_PROGRAM,
  component: TourProgramLine,
  resolve: tourProgramResolver.resolve,
};
